<template>
  <SimpleModal
    :is-open="open"
    @close="close"
  >
    <div class="flex flex-col gap-4 px-7 py-10">
      <div class="flex items-center gap-3 text-gray-900 text-xl leading-6 font-semibold">
        <TransferIcon />
        <span> Update Transfer #{{ transfer.reference_number }} </span>
      </div>

      <div class="gap-3 flex items-center">
        <div class="flex">
          <div
            class="border-2 border-gray-400 rounded-lg overflow-hidden relative flex items-center gap-1"
            :class="{
              'border-red-400': getErrors('origin_id') || getErrors('origin_space_id'),
              'border-gray-400': !getErrors('origin_id') && !getErrors('origin_space_id')
            }"
          >
            <!--                        <select-->
            <!--                            class="w-full border-none font-semibold focus:ring-0 py-0 h-[42px]"-->
            <!--                            name="origin_id"-->
            <!--                            id="origin_id"-->
            <!--                            @change="event => setFormValue('origin_id', event.target.value ? Number(event.target.value) : null)"-->
            <!--                        >-->
            <!--                            <option hidden>{{ selectedOrigin?.name || 'Select Origin' }}</option>-->
            <!--                            <option value="">{{ defaultLocationName }}</option>-->
            <!--                            <option-->
            <!--                                v-for="location in locations"-->
            <!--                                :key="location.id"-->
            <!--                                :value="location.id"-->
            <!--                            >-->
            <!--                                {{ location.name }}-->
            <!--                            </option>-->
            <!--                        </select>-->

            <div class="w-full text-sm px-4 font-semibold flex items-center h-[42px] select-none">
              {{ selectedOrigin?.name }}
            </div>

            <div class="horizontal-divider"></div>

            <!--                        <select-->
            <!--                            class="w-full border-none font-semibold focus:ring-0 py-0 h-[42px]"-->
            <!--                            name="origin_space_id"-->
            <!--                            id="origin_space_id"-->
            <!--                            @change="event => setFormValue('origin_space_id', event.target.value ? Number(event.target.value) : null)"-->
            <!--                        >-->
            <!--                            <option hidden>{{ selectedOriginSpace?.name || 'Select a Space' }}</option>-->
            <!--                            <option value="">Select Space</option>-->
            <!--                            <option-->
            <!--                                v-for="space in originSpaces"-->
            <!--                                :key="space.id"-->
            <!--                                :value="space.id"-->
            <!--                            >-->
            <!--                                {{ space.name }}-->
            <!--                            </option>-->
            <!--                        </select>-->
            <div class="w-full text-sm px-4 font-semibold flex items-center h-[42px] select-none">
              {{ selectedOriginSpace?.name }}
            </div>
          </div>
        </div>

        <ArrowRightCircleIcon class="w-6 h-6 text-gray-800" />

        <div
          class="border-2 border-gray-400 rounded-lg overflow-hidden relative"
          :class="{
            'error-field error-field-group': getErrors('destination_id')
          }"
        >
          <select
            class="w-full border-none font-semibold focus:ring-0 py-0 h-[42px]"
            name="destination_id"
            id="destination_id"
            @change="(event) => setFormValue('destination_id', event.target.value ? Number(event.target.value) : null)"
          >
            <option hidden>{{ selectedDestination?.name || 'Select Destination' }}</option>
            <option
              v-for="location in locations"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
          <!--                     <div class="w-full text-sm px-4 font-semibold flex items-center h-[42px] select-none">-->
          <!--                         {{ selectedDestination?.name }}-->
          <!--                     </div>-->
        </div>
      </div>

      <!-- PACKAGE FINDER -->
      <div class="grid grid-cols-10 gap-5 -mx-7">
        <div class="col-span-10 relative">
          <div class="flex rounded-md">
            <div class="relative flex items-stretch grow focus-within:z-10">
              <div class="absolute inset-y-0 left-3 px-4 flex items-center pointer-events-none">
                <SearchIcon
                  class="h-6 w-6 text-gray-700 mr-4"
                  aria-hidden="true"
                />
                <div class="horizontal-divider"></div>
              </div>
              <input
                v-model="searchQuery"
                @focus="search()"
                @blur="handleSearchBlur()"
                type="text"
                name="search_packages"
                id="search_packages"
                class="bg-gray-300 focus:ring-blue-600 focus:border-blue-600 block w-full sm:text-sm border-gray-400 pl-20 placeholder-gray-800"
                :class="[getErrors('packages') ? 'border-red-600' : '']"
                placeholder="Search Packages"
              />
            </div>
          </div>
          <div
            v-if="searchResults && searchResults.length > 0"
            class="p-5 absolute bg-gray-100 rounded-b-lg w-full z-10 shadow-xl"
          >
            <div class="flex-1 relative max-h-80 overflow-y-auto">
              <ul
                ref="results"
                class="space-y-1"
              >
                <div class="search-table-container">
                  <table class="text-sm w-full">
                    <thead>
                      <tr>
                        <!-- <th>ID</th> -->
                        <th>Item</th>
                        <th class="text-center">Source Inv.</th>
                        <th class="text-center">Dest Inv.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="searching"
                        tabindex="0"
                      >
                        <td colspan="5"><b>Searching...</b></td>
                      </tr>
                      <tr
                        @click="addPackage(item)"
                        v-if="!searching"
                        v-for="(item, index) in searchResults"
                        class="cursor-pointer text-blue-600"
                        tabindex="0"
                      >
                        <!-- <td>{{ item.id }}</td> -->
                        <td>
                          {{ item.sub_lot_num }}
                          <small>{{ item.product_name }}</small>
                        </td>
                        <td class="text-center">{{ item.quantity_available }}</td>
                        <td class="text-center">{{ item.destination_quantity_available }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col divide-y divide-gray-400 max-h-80 overflow-y-auto">
        <div
          v-if="form.packages.length"
          class="flex items-center justify-between uppercase text-gray-600 text-xs font-semibold pb-4"
        >
          <span>Packages</span>
          <span>Count</span>
        </div>
        <!-- SELECTED PACKAGES -->
        <div
          v-for="(item, packageIndex) in form.packages"
          class="flex items-center gap-5"
          :class="{
            'py-4': packageIndex >= 0,
            'pb-0': packageIndex === form.packages.length - 1
          }"
        >
          <button
            type="button"
            @click.prevent="removePackage(packageIndex)"
            class="pl-1.5"
          >
            <MinusCircleIcon
              class="h-6 w-6 text-gray-700"
              aria-hidden="true"
            />
          </button>

          <div class="text-left flex flex-col leading-tight flex-1">
            <span class="uppercase font-bold text-sm text-blue-400">
              {{ item.product_name }}
            </span>
            <span class="text-gray-800 text-sm font-medium flex items-center gap-x-2">
              {{ item.parent_sub_lot_num }}
              <template v-if="item.sub_lot_num">
                <ArrowDownOnSquareStackIcon class="w-6 h-6 text-gray-800 -rotate-90" />
                {{ item.sub_lot_num }}
              </template>
            </span>
            <p
              v-if="countError(item.parent_id)"
              class="mt-2 text-sm text-red-600"
            >
              {{ countError(item.parent_id) }}
            </p>
          </div>

          <div class="">
            <div class="">
              <NumberStepper
                v-model="item.quantity"
                step="1"
                min="0"
                class="h-[36px] w-[70px] flex items-center justify-center border-2 rounded-lg px-4 select-none font-semibold text-sm text-gray-800"
                placeholder="0"
                :class="{
                  'border-red-600 text-red-600': countError(item.parent_id) || quantityError(packageIndex),
                  'bg-gray-100 border-gray-400': !countError(item.parent_id) && !quantityError(packageIndex)
                }"
              />

              <p
                v-if="quantityError(packageIndex)"
                class="mt-2 text-sm text-red-600"
              >
                Must enter a non-zero quantity.
              </p>
            </div>

            <div
              v-if="item.quantity_pre_reserved"
              class="mt-1 ml-4 relative rounded-md"
            >
              <input
                :value="item.quantity_pre_reserved + ' demand'"
                type="text"
                class="border border-gray-600 text-gray-600"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="border-t-2 border-blue-600">
        <div class="flex items-center justify-between pt-4">
          <div class="font-semibold uppercase text-sm">Total Sent</div>
          <div
            class="h-[36px] w-[70px] flex items-center justify-center border-2 border-gray-400 rounded-lg px-4 select-none font-semibold text-sm"
          >
            {{ totalQuantity }}
          </div>
        </div>
      </div>

      <div>
        <div
          v-if="
            getErrors('packages') ||
            getErrors('destination_id') ||
            getErrors('origin_id') ||
            getErrors('origin_space_id')
          "
          class="bg-red-400 py-4 px-6 text-gray-100 rounded-b-lg -mx-7 -mb-12 flex items-center justify-between"
        >
          <div class="flex items-center gap-3 ml-5">
            <ExclamationCircleIcon
              class="h-7 w-7 text-gray-100"
              aria-hidden="true"
            />
            <div class="flex flex-col">
              <span
                v-if="getErrors('packages')"
                class="text-gray-100 leading-snug block text-xs font-semibold"
              >
                {{ getErrors('packages') }}
              </span>

              <span
                v-if="getErrors('destination_id')"
                class="text-gray-100 leading-snug block text-xs font-semibold"
              >
                {{ getErrors('destination_id') }}
              </span>

              <span
                v-if="getErrors('origin_id')"
                class="text-gray-100 leading-snug block text-xs font-semibold"
              >
                {{ getErrors('origin_id') }}
              </span>

              <span
                v-if="getErrors('origin_space_id')"
                class="text-gray-100 leading-snug block text-xs font-semibold"
              >
                {{ getErrors('origin_space_id') }}
              </span>
            </div>
          </div>
          <div class="flex gap-4">
            <button
              @click.prevent="submit()"
              :disabled="creating"
              type="button"
              class="btn px-3 py-3 text-red-600 w-24 uppercase font-semibold"
            >
              {{ submitText }}
            </button>
            <button
              @click="close()"
              type="button"
              class="btn px-3 py-3 text-gray-100 w-24 uppercase font-semibold bg-red-400 border-2 border-gray-100"
            >
              Cancel
            </button>
          </div>
        </div>
        <div
          v-else
          class="flex gap-3"
        >
          <button
            @click.prevent="submit()"
            :disabled="creating"
            type="button"
            class="btn btn-primary px-12 py-3 font-semibold uppercase"
          >
            {{ submitText }}
          </button>
          <button
            @click="close()"
            type="button"
            class="btn px-3 py-3 font-semibold uppercase border-none text-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </SimpleModal>
</template>

<style scoped>
.horizontal-divider {
  height: calc(100% - 20px);
  width: 2px;
  @apply bg-gray-500;
}
</style>

<script setup>
import { ref, watch, computed } from 'vue'
import { useForm } from '@inertiajs/vue3'
import SimpleModal from '@/Components/Modals/SimpleModal.vue'
import { ExclamationCircleIcon, SearchIcon } from '@heroicons/vue/solid'
import { usePageErrors } from '@/Composables/access-page-errors'
import { ArrowRightCircleIcon, ArrowDownOnSquareStackIcon } from '@heroicons-2/vue/24/outline'
import NumberStepper from '@/Components/Forms/NumberStepper.vue'
import { MinusCircleIcon } from '@heroicons/vue/outline'
import TransferIcon from '@/Components/Icons/TransferIcon.vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  defaultLocationName: {
    type: String,
    default: 'Default Store'
  },
  locations: {
    type: Array,
    default: () => []
  },
  spaces: {
    type: Array,
    default: () => []
  },
  /**
   * The type of transfer being made.
   */
  transferType: {
    type: String,
    default: 'standard'
  },
  /**
   * An existing transfer to modify instead of create.
   * Will set initial form values.
   */
  transfer: {
    required: true,
    type: Object
  }
})

const emit = defineEmits(['update:open', 'updated'])

const form = useForm({
  type: props.transferType,
  origin_id: null,
  origin_space_id: null,
  destination_id: null,
  destination_space_id: null,
  packages: [],
  order_item_ids: []
})

const searchQuery = ref(null)
const searching = ref(false)
const searchResults = ref(false)
const creating = ref(false)

const errors = usePageErrors('createTransfer')

const submitText = computed(() => {
  return creating.value ? 'Saving...' : 'Update'
})
const selectedOrigin = computed(() => {
  return props.locations.find((location) => location.id === form.origin_id)
})
const selectedOriginSpace = computed(() => {
  return props.spaces.find((space) => space.id === form.origin_space_id)
})
const originSpaces = computed(() => {
  return props.spaces.filter((space) => space.location_id === form.origin_id)
})
const selectedDestination = computed(() => {
  return props.locations.find((location) => location.id === form.destination_id)
})
const totalQuantity = computed(() => {
  return (
    _.reduce(
      form.packages,
      function (sum, item) {
        return parseFloat(sum) + parseFloat(item.quantity)
      },
      0
    ) || 0
  )
})

watch(
  () => props.transfer,
  (newVal) => {
    initializeForm()
  }
)
watch(searchQuery, (newVal) => {
  if (!newVal) {
    clearSearch()
  } else {
    search()
  }
})

const initializeForm = () => {
  form.reset()

  const { origin_id, origin_space_id, destination_id, destination_space_id, packages } = props.transfer

  form.origin_id = origin_id
  form.origin_space_id = origin_space_id
  form.destination_id = destination_id
  form.destination_space_id = destination_space_id
  form.packages = packages
}

const close = () => {
  emit('update:open', false)
}

const setFormValue = (key, val) => {
  console.log('setting', key, val)
  form[key] = val

  clearSearch()
}

const handleSearchBlur = () => {
  setTimeout(() => {
    searchResults.value = []
    searching.value = false
  }, 500)
}

const searchErrors = ref([])

const search = _.debounce(
  function () {
    searching.value = true

    axios
      .post(route('packages.search'), {
        query: searchQuery.value,
        origin_id: form.origin_id,
        origin_space_id: form.origin_space_id,
        destination_id: form.destination_id,
        show_unpublished: true
      })
      .then((response) => {
        searchErrors.value = []
        searchResults.value = response.data.data || []
        searching.value = false
      })
      .catch((error) => {
        searchErrors.value = error.response?.data?.errors ?? []
        searching.value = false
      })
  },
  500,
  {
    leading: false,
    trailing: true
  }
)

const clearSearch = () => {
  searchQuery.value = null
  searchResults.value = []
  searching.value = false
}

const addPackage = (item, quantity = 0) => {
  const { name, tag_num, batch_num } = item.details

  form.packages.push({
    details: { name, tag_num, batch_num },
    parent_id: item.id,
    quantity: quantity,
    quantity_pre_reserved: 0,
    parent_sub_lot_num: item.sub_lot_num
  })

  clearSearch()
}

const selectedPackageLabel = (item) => {
  let val = `#${item.parent_id}: ${item.details.name}`

  if (item.parent_sub_lot_num) {
    val += ` - Sub-Lot: ${item.parent_sub_lot_num}`
  }

  return val
}

const removePackage = (pkgIndex) => {
  form.packages = _.filter(form.packages, (pkg, index) => index !== pkgIndex)
}

const quantityError = (packageIndex) => {
  return errors.value?.[`packages.${packageIndex}.quantity`] || null
}

const countError = (packageId) => {
  return errors.value?.[`package_${packageId}_count`] || null
}

const submit = () => {
  creating.value = true

  console.log('posting', form, 'to', route('transfers.update', { transfer: props.transfer.id }))

  form.put(route('transfers.update', { transfer: props.transfer.id }), {
    errorBag: 'createTransfer',
    onSuccess: (response) => {
      form.reset()
      emit('updated')
    },
    onFinish: (response) => {
      creating.value = false
    }
  })
}

const getErrors = (field) => {
  let errors = form.errors || {}

  if (field in errors) {
    return errors[field]
  }

  // Each field has an array of one or more errors associated with it when performing a search.
  // For the sake of compatibility with the existing error handling, we'll return the first error.
  if (field in searchErrors.value) {
    return searchErrors.value[field][0]
  }

  return ''
}
</script>
